// src/clearance.js
import { VehicleManager } from '../vehicleManager.js';
import { clearanceDefaults } from './clearance-form-defaults.js';
import {
   setupInputChangeHandlers,
   buildClearanceInputJson,
   setupDynamicHandlers,
   getCurrentDiagramView,
   refreshDiagramView,
} from './clearance-form-input-handler.js';
import { initResults } from './clearance-results.js';
import { runAnalysis } from './clearance-req.js';
import { updateUnitSideSVG } from './clearance-form-svg.js';
import { initScene, isSceneInitialized } from './clearance-results-3d.js';
import { setupBootstrapTabs } from '../utils.js';
import { clearCombinationSVG } from './clearance-form-svg.js';

let v; //VehicleManager instantiated in load page

const startingVehicles = {
   v1: { group: 0, type: 0 },
};

$(function () {
   try {
      v = new VehicleManager('wa-trailer-clearance');

      initHandlers();
      loadPage(); // get the vehicles database and refresh the page.
      initResults();

      // Attach handler for when the results tab is shown
      setupBootstrapTabs('#topTabs', (panelId, element) => {
         if (panelId === '#results') {
            // reset the results view each time the tab is shown
            $('#viewSummary').prop('checked', true);

            const formValues = buildClearanceInputJson();
            runAnalysis(formValues); // async
         }
      });

      // Attach a shown handler to the results sub tabs
      setupBootstrapTabs('#visTabs', (panelId, element) => {
         //console.log('Tab shown main js:', panelId);

         // If the 3D tab is shown, initialize the scene if not already done
         if (panelId === '#threeD-svg') {
            const threeSceneInitialized = isSceneInitialized();
            if (!threeSceneInitialized) {
               initScene('threeContainer');
            }
         }
      });
   } catch (error) {
      console.error(error.message);
      window.location.href =
         '/error?message=' + encodeURIComponent('An unexpected error occurred on starting the clearance tool.');
   }

   // JS to mirror .active onto <li> in left hand aside navigation
   $('#vehicle-unit-section').on('click', '#unitNav .nav-link', function () {
      // Remove active from all unit-item <li>
      $('#unitNav .unit-item').removeClass('active');

      // Add active to the clicked tab's parent <li>
      $(this).closest('.unit-item').addClass('active');
   });
});

function loadPage() {
   // Populate vehicle types dropdowns
   const groups = v.getVehicleGroups();
   $('.vehicle-group').empty();
   for (let i = 0; i < groups.length; i++) {
      const name = groups[i].name;
      const val = groups[i].index;
      $('#vehicle-category-select').append(new Option(name, val));
   }

   // retrieve available vehicles and then populate page
   const customEntries = [];
   v.initVehicles(customEntries, function () {
      resetFormValues(startingVehicles.v1.group, startingVehicles.v1.type);
   });
}

function initHandlers() {
   // handle vehicle group and type changing
   $('.vehicle-group').on('change', function () {
      selectVehicleGroup(this.value); // also sets default vehicle group
   });
   $('.vehicle-type').on('change', function () {
      selectVehicleType(this.value);
   });

   // reset defaults button click handler
   $('#vehicle-unit-section').on('click', '.reset-defaults-btn', function () {
      const index = $(this).data('unit-index');
      const unitType = $(`#unit-${index}`).data('unit-type');
      applyUnitTypeFieldVisibility(index, unitType, true);
      if (index >= 0) {
         handleInputChange(index);
      }
   });

   // show results button click handler
   $('#vehicle-unit-section').on('click', '.show-results-btn', async function () {
      const tabEl = document.querySelector('#results-tab');
      // show the results tab and trigger the analysis
      if (tabEl) {
         const tab = new bootstrap.Tab(tabEl);
         tab.show();
      }
   });

   // analysis button click handler
   $('#runAnalysisBtn').on('click', async function () {
      const formValues = buildClearanceInputJson();
      await runAnalysis(formValues);
   });

   // Handle unit form changes, uses debouncing to avoid excessive renders of unit diagram
   setupInputChangeHandlers(handleInputChange);

   // Setup dynamic handlers for view switching buttons
   setupDynamicHandlers();
}

function resetFormValues(groupIndex, vehicleIndex) {
   $(`#vehicle-category-select`).val(groupIndex);
   selectVehicleGroup(groupIndex, vehicleIndex);
}

function selectVehicleGroup(groupIndex, vehicleIndex = 0) {
   $(`#vehicle-category-select`).val(groupIndex);
   v.setVehicleGroup(groupIndex);
   const names = v.getActiveGroupVehicleNames();

   $(`#vehicle-type`).empty();
   for (let i = 0; i < names.length; i++) {
      $(`#vehicle-type`).append(new Option(names[i], i));
   }

   $(`#vehicle-type`).val(vehicleIndex);
   selectVehicleType(vehicleIndex); //default first entry =0
}

function selectVehicleType(vehicleIndex) {
   // Called when user changes vehicle type
   v.setActiveVehicle(vehicleIndex);
   const selectedVehicle = v.getActiveVehicle();
   const path = v.getImagePath();

   $(`#vehicleImage`).attr('src', path + selectedVehicle.image);
   $(`#info-vehicle`).text(`${selectedVehicle.description}`);
   $(`#info-length`).text(selectedVehicle.length);
   clearCombinationSVG();
   updateVehicleUnitSection(selectedVehicle.units);
}

function updateVehicleUnitSection(units) {
   // Partial render the vehicle unit section
   $.post('/clearance/unit-section', { units }, function (html) {
      $('#vehicle-unit-section').html(html);
      // Activate first tab programmatically
      const firstTab = $('#unitNav .nav-link').first().get(0);
      if (firstTab) {
         const tab = new bootstrap.Tab(firstTab);
         tab.show();
      }

      // Apply field visibility per unit
      applyAllUnitFieldVisibility(units);
      // removes was-default when overridden
      watchDefaultOverrides();

      // show the first unit diagram
      if (units.length > 0) {
         handleInputChange(0); // Render the first unit diagram
      }
   }).fail(function (err) {
      console.error('Error rendering unit section:', err);
   });
}

/**
 * After render, show/hide fields in the unit form based on the selected unit type.
 */
function applyAllUnitFieldVisibility(units) {
   units.forEach((unit, index) => {
      applyUnitTypeFieldVisibility(index, unit.unitType);
   });
}

/* Show/hide fields for a unit based on unitType,
 * apply defaults only to empty fields,
 * and tag them visually and semantically when used.
 */
function applyUnitTypeFieldVisibility(unitIndex, unitType, reset = false) {
   if (!unitType) return;
   // Normalize unitType to lowercase for matching
   const normalizedUnitType = unitType.toLowerCase();
   const defaultValues = clearanceDefaults[normalizedUnitType] || {};

   const $form = $(`#unit-${unitIndex} .accordion`);
   $form.find('[data-visible-for]').each(function () {
      const allowedTypes = $(this).attr('data-visible-for').toLowerCase().split(/\s+/);
      const shouldShow = allowedTypes.includes(normalizedUnitType);
      $(this).toggle(shouldShow);
      if (shouldShow) {
         const $input = $(this).find('[data-field]');
         const fieldId = $input.attr('data-field');

         if (!fieldId || defaultValues[fieldId] === undefined) return;

         const isEmpty = $input.is(':checkbox') ? !$input.prop('checked') : $input.val() === '' || $input.val() == null;

         if (isEmpty || reset) {
            //console.log(`Applying default value for ${fieldId} in unit ${unitIndex}:`, defaultValues[fieldId]);
            const defaultValue = defaultValues[fieldId];
            if ($input.is(':checkbox')) {
               $input.prop('checked', Boolean(defaultValue));
            } else {
               $input.val(defaultValue);
            }

            // Mark field as defaulted
            $input.addClass('was-default');
            $input.attr('data-default-applied', 'true');
         }
      }
   });
}

// Watch for changes to inputs with default values
function watchDefaultOverrides(containerSelector = '#vehicle-unit-section') {
   $(containerSelector).on('input change', '[data-default-applied]', function () {
      $(this).removeClass('was-default').removeAttr('data-default-applied');
   });
}

// Handle input change for a specific unit
// This function is called when any input in the unit form changes, or new vehicle unit is selected
function handleInputChange(unitIndex) {
   const unitData = buildClearanceInputJson();

   updateUnitSideSVG(unitIndex, unitData); // keep updated anyway
   const currentView = getCurrentDiagramView(unitIndex);

   refreshDiagramView(unitIndex, currentView, true); // doesn't refresh unit-side view
}
